var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "3.85108612e-14%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1572CB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#084C8A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "76.4970624%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.863636,1.000000),rotate(40.815084),translate(-0.500000,-0.500000)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19,73.4485349 C20.0586745,73.5832692 21.139637,73.6562503 22.2317434,73.6562503 C28.5782187,73.6674782 34.4176446,71.3601533 39.0479528,67.4865421 C33.1193753,67.3461939 28.1213171,63.1245191 26.3995779,57.3309442 C27.2242296,57.504976 28.0767413,57.6060267 28.9459688,57.6116407 C30.1829465,57.6172545 31.3753483,57.4488367 32.5120305,57.1232288 C26.3159985,55.7422022 21.6466865,49.8195069 21.6466865,42.7627979 C21.6466865,42.7010446 21.6466865,42.6392914 21.6466865,42.5775382 C23.4742931,43.6890962 25.5582103,44.3627677 27.7814268,44.4638184 C24.1540734,41.8196578 21.7636977,37.3285144 21.7636977,32.2759781 C21.7636977,29.6037479 22.4323343,27.1111633 23.5968763,24.9778702 C30.2776699,33.8759479 40.2570705,39.7818015 51.5068806,40.5172262 C51.2728578,39.4561935 51.1558463,38.3502495 51.1558463,37.2218497 C51.1558463,29.2444563 57.2181512,22.8782606 64.6957366,23.0017671 C68.5905446,23.0691342 72.1120304,24.8712055 74.5804137,27.7006258 C77.6672858,27.1055493 80.5647108,25.9603077 83.1779653,24.3603379 C82.1694386,27.689398 80.0186576,30.462679 77.221528,32.1973832 C79.9629379,31.8886171 82.5706204,31.1588063 85,30.0528622 C83.1835374,32.8991242 80.8878852,35.3860949 78.2411989,37.3734259 C78.2690587,37.9909581 78.2802026,38.6084903 78.2802026,39.2260225 C78.2802026,58.1674197 64.6567329,80.0112181 39.7500211,80 C32.1108484,80.0056042 24.9898691,77.5916146 19,73.4485349 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-11.4%",
    y: "-13.2%",
    width: "119.7%",
    height: "122.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pop-up",
    transform: "translate(-660.000000, -230.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27",
    transform: "translate(660.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,50 C100,22.3863637 77.6136363,0 50,0 C22.3863637,0 0,22.3863637 0,50 C0,77.6136363 22.3863637,100 50,100 C77.6136363,100 100,77.6136363 100,50 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-2)",
    xlinkHref: "#path-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupTwitterLogo);
export default __webpack_public_path__ + "static/media/popup-twitter-logo.06ebf1561708bfeb72fd755badc7205b.svg";
export { ForwardRef as ReactComponent };